import AccountInfo from "state/AccountInfo";
import BaseReporter from "landings/Analytics/BaseReporter";

/**
 * Mixpanel上报实现
 */
export default class MixpanelReporter extends BaseReporter {
    private static sInited;

    init() {
        if (!MixpanelReporter.sInited) {
            if (window.mixpanel) {
                window.mixpanel?.init("f48e3dc7019dd525118fc1f94b51cb3f");
                MixpanelReporter.sInited = true;
            }
        }
    }

    report(eventName: string, data?: object) {
        if (MixpanelReporter.sInited) {
            try {
                window.mixpanel?.track(eventName, data);
            } catch (e) {}
        }
    }

    setProfile(locale: string, accountInfo: AccountInfo) {
        if (!MixpanelReporter.sInited) {
            this.init();
        }

        if (MixpanelReporter.sInited && accountInfo.userId) {
            try {
                window.mixpanel?.identify(accountInfo.userId);
                window.mixpanel?.people.set({
                    uid: accountInfo.userId,
                    sign_up_date: accountInfo.createTime,
                    vip_status: accountInfo.membership,
                    name: accountInfo.nickname,
                    // 以上是保留老的格式字段，以下是新的格式
                    ...BaseReporter.FormateLoginProfile(locale, accountInfo),
                });
            } catch (e) {}
        }
    }

    reset() {
        if (MixpanelReporter.sInited) {
            window.mixpanel?.reset();
        }
    }

    updateProfile(userId: string, profile: {}) {
        if (MixpanelReporter.sInited && userId) {
            try {
                window.mixpanel?.identify(userId);
                window.mixpanel?.people.set(profile);
            } catch (e) {}
        }
    }
}
